import ModalBackButton from "../components/ModalBackButton";
import PaymentMethodButton from "../components/PaymentMethodButton";
import TransactionCheckoutHeader from "../components/TransactionCheckoutHeader";
import EVMWalletsLogo from "../logos/EVMWalletsLogo";
import { SectionTitle } from "../components/SectionTitle";

type Props = {
  onSelect: (destination: "wallet") => void;
  onBack?: () => void;
};

export function WithdrawDestination({ onBack, onSelect }: Props) {
  return (
    <>
      {onBack ? <ModalBackButton onClick={() => onBack()} /> : null}

      <TransactionCheckoutHeader title="Withdraw" />

      <SectionTitle
        title="Destination"
        subtitle="Pick where you’d like to receive your tokens"
      />

      <div className="space-y-3">
        <PaymentMethodButton
          icon={<EVMWalletsLogo className="h-8 w-8" />}
          title="Wallet"
          subtitle={"Send tokens to your wallet on any chain"}
          onClick={() => onSelect("wallet")}
        />
      </div>
    </>
  );
}
